/**
 * The "Connecting…" placeholder painted on the canvas while no real frame has arrived.
 *
 * It exists for a safety reason, not decoration: leaving the previous phone's last frame on screen
 * looks connected, and a tap on that stale picture is delivered to the NEW phone at whatever happens
 * to be under those coordinates. So the canvas is wiped the moment a session changes, and taps stay
 * refused until a frame of the current device has actually been painted.
 */

export class CanvasPlaceholder {
  private timer: ReturnType<typeof setInterval> | null = null
  private dots = 0

  constructor(private readonly canvas: HTMLCanvasElement) {}

  start(label: string): void {
    this.stop()
    const paint = () => {
      const ctx = this.canvas.getContext('2d')
      if (!ctx) return
      const { width, height } = this.canvas
      ctx.fillStyle = '#0d1117'
      ctx.fillRect(0, 0, width, height)
      // An empty label means "just wipe it": the panel draws its own progress over the canvas, and
      // two centred captions on top of each other read as a rendering bug.
      if (!label) return
      const scale = Math.max(1, Math.min(width / 360, height / 800))
      ctx.fillStyle = '#8b949e'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.font = `${Math.round(15 * scale)}px system-ui, sans-serif`
      this.dots = (this.dots % 3) + 1
      ctx.fillText(label + '.'.repeat(this.dots), width / 2, height / 2)
    }
    paint()
    this.timer = setInterval(paint, 450)
  }

  stop(): void {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
